import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const assetsSearchEntryPoint = createEntryPoint({
	root: JSResourceForUserVisible(() => {
		if (!__SERVER__) {
			return import(/* webpackChunkName: "assets-app-search" */ './src/ui').then(
				(module) => module.AssetsAppSearchEntrypointWrapper,
			);
		}
		// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
		return Promise.resolve(() => null) as unknown as Promise<
			typeof import('./src/ui').AssetsAppSearchEntrypointWrapper
		>;
	}),
	getPreloadProps: () => ({}),
});
